import { gql } from 'graphql-request';

const getShopifyCustomerAccessToken = () => {
    return gql`
        mutation customerAccessTokenCreateWithMultipass(
            $multipassToken: String!
        ) {
            customerAccessTokenCreateWithMultipass(
                multipassToken: $multipassToken
            ) {
                customerAccessToken {
                    accessToken
                    expiresAt
                }
                customerUserErrors {
                    code
                    field
                    message
                }
            }
        }
    `;
};

const getShopifyCustomer = () => {
    return gql`
        query customer($customerAccessToken: String!) {
            customer(customerAccessToken: $customerAccessToken) {
                id
                firstName
                lastName
                acceptsMarketing
                email
                phone
                metafields(
                    identifiers: [
                        { namespace: "c_f", key: "bc_payment_method_code" }
                    ]
                ) {
                    key
                    value
                }
            }
        }
    `;
};

export { getShopifyCustomerAccessToken, getShopifyCustomer };
